import { AlertTriangle, CheckCircle, Info, X, XCircle } from 'lucide-react'

import { type ToastVariant,useToast } from '@/hooks/useToast'
import { cn } from '@/lib/utils'

const variantConfig: Record<
  ToastVariant,
  { icon: typeof CheckCircle; bg: string; text: string }
> = {
  success: {
    icon: CheckCircle,
    bg: 'bg-green-500',
    text: 'text-white',
  },
  error: {
    icon: XCircle,
    bg: 'bg-red-500',
    text: 'text-white',
  },
  info: {
    icon: Info,
    bg: 'bg-blue-500',
    text: 'text-white',
  },
  warning: {
    icon: AlertTriangle,
    bg: 'bg-yellow-500',
    text: 'text-white',
  },
}

export function ToastContainer() {
  const { toasts, dismiss } = useToast()

  return (
    <div className="fixed top-4 right-4 z-toast space-y-2 pointer-events-none">
      {toasts.map((toast) => {
        const config = variantConfig[toast.variant]
        const Icon = config.icon

        return (
          <div
            key={toast.id}
            className={cn(
              'pointer-events-auto',
              'flex items-center gap-3 px-4 py-3 rounded-lg shadow-lg',
              'animate-slide-up',
              config.bg,
              config.text
            )}
          >
            <Icon className="w-5 h-5 flex-shrink-0" />
            <div className="flex-1 text-sm font-medium">{toast.message}</div>
            <button
              onClick={() => dismiss(toast.id)}
              className="hover:opacity-80 transition-opacity"
              aria-label="Dismiss"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        )
      })}
    </div>
  )
}

